import { Group, Text } from "@mantine/core";
import { IconPointFilled } from "@tabler/icons-react";
import classes from "./CountBadge.module.css";

export const CountBadge = ({ count, label, color, ...props }) => (
    <Group
        className={classes.pill}
        gap={8}
        wrap="nowrap"
        {...props}
    >
        <span style={{ width: 8, height: 8, backgroundColor: color, borderRadius: '50%' }} />
        <Text span fz={14}>
            <Text span className={classes.count} c="var(--count-fg)">{count ?? 0}</Text>{' '}
            <Text span fw={400} className={classes.label} c="var(--label-fg)">{label}</Text>
        </Text>
    </Group>
);
